<template>
    <div>
        <Breadcumb title="Actualités" :breadcumb-data="breadcumbData">
        </Breadcumb>
        <b-card class="mb-3 cardcontainer" v-if="user.userprofile.user_type.slug == 'pilote_global' || user.userprofile.user_type.slug == 'pilote_com' || user.userprofile.user_type.slug == 'obea_admin'">
            <b-form-group label="Cette actualité est prioritaire" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                <input style="height:20px; width:20px; margin-top:8px" type="checkbox" value="true" v-model="priority"/>
            </b-form-group>
            <b-form-group label="Actualité" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                <b-textarea placeholder="Votre commentaire" :rows="5" v-model="comment"/>
            </b-form-group>
            <b-btn v-on:click="addComment" variant="primary"><i class="ion ion-md-create"></i>&nbsp; Publier</b-btn>
        </b-card>
        <div v-if="user.userprofile.user_type.slug != 'pilote_com' && user.userprofile.user_type.slug != 'obea_admin'" class="cardcontainer">
        </div>
            <b-card class="mb-3" v-for="item in news" :key="item.id">
                
                <div class="media">
                    <div class="media-body ml-4">
                        <div class="float-right text-muted small">{{item.date_created|formatDate}}</div>
                        <a href="javascript:void(0)">{{item.author.firstname}} {{item.author.lastname}}</a>
                        <div class="mt-2" v-html="item.content"></div>
                    </div>
                </div>
            
            </b-card>
    </div>
</template>

<script>
    import * as numeral from 'numeral'
    import {
        ADD_COMMENT_REQUEST,
        ADD_NEWS_REQUEST,
        GET_FORUMARTICLE_REQUEST,
        GET_NEWS_REQUEST
    } from "../_store/exchange/actiontypes";
    import Breadcumb from '../components/breadcumb'
    import { mapState } from 'vuex';

    export default {
        name: 'pages-forums-discussion',
        components: { Breadcumb},
        computed: mapState({ news: state => state.exchange.news,
            user: state => state.user.user}),
        data() {
            return {
                breadcumbData: [
                    { text: 'Accueil', href: '/dashboard/' },
                    { text: 'Actualités', active:true },
                ],
                comment: '',
                priority: false,
            }
        },
        methods: {
            addComment: function(e) {
                e.preventDefault()
                this.$store.dispatch(ADD_NEWS_REQUEST, {
                    content: this.comment,
                    priority: this.priority
                })
                    .then(() => {
                        this.$router.push("/echanges/news/");
                        this.$store.dispatch(GET_NEWS_REQUEST);
                        this.comment = '';
                        this.priority = false;
                    })
            }
        },
        mounted () {
            this.$store.dispatch(GET_NEWS_REQUEST)
                .then(() => {
                    this.breadcumbData = [
                        {text: this.$t('welcome'), href: '/dashboard/'},
                        {text: "Actualités", active:true}
                    ];
                    console.log(this.breadcumbData)
                })
        }
    }
</script>
